import CellCopyManager from './slick.cellcopymanager';
export default CellCopyManager;
